import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Buy2WinComponent } from './buy-2-win/buy-2-win.component';
import { CampaignDetailsComponent } from './buy-2-win/campaign-details/campaign-details.component';
import { CampaignGenerateComponent } from './campaigns/campaign-generate/campaign-generate.component';
import { CampaignHistoryComponent } from './campaigns/campaign-history/campaign-history.component';
import { CampaignRulesComponent } from './campaigns/campaign-rules/campaign-rules.component';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { CouponDetailComponent } from './coupons/coupon-detail/coupon-detail.component';
import { CouponsComponent } from './coupons/coupons.component';
import { EmailTemplatesComponent } from './email-templates/email-templates.component';
import { MgmComponent } from './mgm/mgm.component';
import { MgmCycleDetailComponent } from './mgm/mgm-cycle-detail/mgm-cycle-detail.component';
import { MgmCycleFormComponent } from './mgm/mgm-cycle-form/mgm-cycle-form.component';
import { ShopCouponDetailComponent } from './shop-coupons/shop-coupon-detail/shop-coupon-detail.component';
import { ShopCouponsComponent } from './shop-coupons/shop-coupons.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'coupons' },
  { path: 'coupons', component: CouponsComponent },
  { path: 'campaigns', component: CampaignsComponent },
  { path: 'campaigns/new', component: CampaignRulesComponent },
  {
    path: 'campaigns/:campaignId/generate',
    component: CampaignGenerateComponent
  },
  {
    path: 'campaigns/:campaignId/history',
    component: CampaignHistoryComponent
  },
  { path: 'campaigns/:campaignId', component: CampaignRulesComponent },
  { path: 'coupons/:couponId', component: CouponDetailComponent },
  { path: 'shop-coupons', component: ShopCouponsComponent },
  { path: 'shop-coupons/new', component: ShopCouponDetailComponent },
  { path: 'shop-coupons/:couponId', component: ShopCouponDetailComponent },
  {
    path: 'buy-2-win',
    component: Buy2WinComponent
  },
  {
    path: 'buy-2-win/:campaignId',
    component: CampaignDetailsComponent
  },
  {
    path: 'email-templates',
    component: EmailTemplatesComponent
  },
  { path: 'email-templates/new', component: EmailTemplatesComponent },
  {
    path: 'mgm',
    component: MgmComponent
  },
  {
    path: 'mgm/new',
    component: MgmCycleFormComponent
  },
  {
    path: 'mgm/:cycleId',
    component: MgmCycleDetailComponent
  },
  {
    path: 'mgm/:cycleId/edit',
    component: MgmCycleFormComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MarketingRoutingModule {}
